import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c72d713e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c72d713e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72d713e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72d713e')) {
      api.createRecord('c72d713e', component.options)
    } else {
      api.reload('c72d713e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c72d713e&scoped=true&", function () {
      api.rerender('c72d713e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gVCLASzI6pkD/JS/comp/SearchFilterTokens.vue"
export default component.exports